import { Colors, Services, isEmpty, joinURLPath, projectName } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'

import { globalErrorHandler, isValidPhone, macroCacheOptions, request } from '@/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)
const cachedGet = Cache.wrapWithCache(async (key, value) => {
  return await request.get(joinURLPath(Services.hlr, value))
})

export default {
  name: Services.hlr,

  data() {
    return {
      searchQuery: undefined,
      searchResult: undefined,

      loading: false,
      empty: false
    }
  },

  computed: {
    validation() {
      return isValidPhone(this.searchQuery)
    },

    emptyProps() {
      if (this.empty) {
        return {
          messagePath: `${Services.dictionaries}.hints.search.empty`,
          color: Colors.warning
        }
      }

      return {
        messagePath: `${Services.hlr}.hints.empty`,
        color: Colors.grey
      }
    }
  },

  watch: {
    searchQuery(searchQuery) {
      if (isEmpty(searchQuery)) {
        this.searchResult = undefined
        this.empty = false
      }
    }
  },

  methods: {
    async search() {
      if (this.validation) {
        try {
          this.loading = true
          this.empty = false
          this.searchResult = undefined
          const key = [ projectName, Services.hlr, 'get', this.searchQuery ].filter(Boolean).join(':')
          const data = await cachedGet(key, this.searchQuery)
          if (data && Object.keys(data).length > 0) {
            this.searchResult = data
          } else {
            this.empty = true
          }
        } catch (error) {
          globalErrorHandler(error)
        } finally {
          this.loading = false
        }
      }
    }
  },

  render
}
